import Highcharts from '~/scripts/integrations/highcharts';

class OffsiteTeamGatheringCalculator {
  constructor() {
    this.charts = {};
    this.init();
  }

  init() {
    this.bindEvents();
    this.createCharts();
    this.setDefaultValues();
  }

  bindEvents() {
    $('#calculate-gathering-budget').on('click', () => this.calculateBudget());
    // export removed per requirements
    $('#reset-gathering-calculator').on('click', () => this.resetCalculator());
    $('#add-flight-cost').on('click', () => this.addFlightCostEntry());
    
    // Auto-calculate on input changes
    $('input, select').on('input change', () => {
      if (this.hasValidInputs()) {
        this.calculateBudget();
      }
    });
    
    // Handle flight cost removal
    $(document).on('click', '.remove-flight-cost', (e) => {
      $(e.target).closest('.flight-cost-entry').remove();
      this.updateAttendeeCount();
      this.updateRoomsNeeded();
      this.updateFlightCostsChart();
      if (this.hasValidInputs()) {
        this.calculateBudget();
      }
    });

    // Handle flight cost input changes
    $(document).on('input', '.flight-cost-entry input', () => {
      this.updateFlightCostsChart();
      if (this.hasValidInputs()) {
        this.calculateBudget();
      }
    });
  }

  setDefaultValues() {
    // Set current date
    const today = new Date();
    const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
    $('#event-date').val(nextMonth.toISOString().split('T')[0]);
    
    // Set reasonable defaults
    $('#destination-city').val('San Francisco, CA');
    $('#hotel-name').val('Marriott Downtown');
    $('#hotel-rate').val(250);
    $('#ground-transportation').val(50);
    $('#parking-fees').val(25);
    $('#rental-cars').val(80);
    $('#breakfast-cost').val(25);
    $('#lunch-cost').val(35);
    $('#dinner-cost').val(45);
    $('#snacks-beverages').val(15);
    $('#welcome-dinner').val(75);
    $('#farewell-dinner').val(75);
    $('#team-building-activities').val(100);
    $('#guided-tours').val(50);
    $('#adventure-activities').val(75);
    $('#evening-entertainment').val(40);
    $('#photography-videography').val(1500);
    $('#swag-gifts').val(50);
    $('#conference-room-rental').val(500);
    $('#av-equipment').val(800);
    $('#wifi-internet').val(200);
    $('#meeting-supplies').val(300);
    $('#insurance').val(500);
    $('#permits-licenses').val(200);
    $('#emergency-fund').val(1000);
    $('#misc-costs').val(500);
    
    // Add some default flight cost entries
    this.addFlightCostEntry('John Smith', 450);
    this.addFlightCostEntry('Jane Doe', 380);
    this.addFlightCostEntry('Mike Johnson', 520);
    
    // Update rooms needed based on initial attendee count
    this.updateRoomsNeeded();
  }

  hasValidInputs() {
    const attendeeCount = parseInt($('#attendee-count').text()) || 0;
    const eventDuration = parseInt($('#event-duration').val()) || 0;
    return attendeeCount > 0 && eventDuration > 0;
  }

  addFlightCostEntry(name = '', cost = 0) {
    const entryId = 'flight-cost-' + Date.now();
    const flightCostEntry = `
      <div class="col-md-6 mb-2 flight-cost-entry" id="${entryId}">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Person name" value="${name}" data-field="name">
          <span class="input-group-text">$</span>
          <input type="number" class="form-control" placeholder="Flight cost" value="${cost}" min="0" data-field="cost">
          <span class="input-group-text">round trip</span>
          <button type="button" class="btn btn-outline-danger remove-flight-cost" title="Remove">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
    `;
    $('#flight-costs-list').append(flightCostEntry);
    
    // Update attendee count and rooms needed
    this.updateAttendeeCount();
    this.updateRoomsNeeded();
    
    // Update charts and calculate if we have valid inputs
    this.updateFlightCostsChart();
    if (this.hasValidInputs()) {
      this.calculateBudget();
    }
  }

  updateAttendeeCount() {
    const flightCostEntries = $('.flight-cost-entry').length;
    $('#attendee-count').text(flightCostEntries);
  }

  updateRoomsNeeded() {
    const attendeeCount = parseInt($('#attendee-count').text()) || 0;
    // Assume 2 people per room (typical for business travel)
    const roomsNeeded = Math.ceil(attendeeCount / 2);
    $('#rooms-needed').val(roomsNeeded);
  }

  getFlightCosts() {
    const flightCosts = [];
    $('.flight-cost-entry').each(function() {
      const name = $(this).find('[data-field="name"]').val().trim();
      const cost = parseFloat($(this).find('[data-field="cost"]').val()) || 0;
      if (name && cost > 0) {
        flightCosts.push({ name, cost });
      }
    });
    return flightCosts;
  }

  createCharts() {
    this.createPieChart();
    this.createBarChart();
    this.createFlightCostsChart();
  }

  createPieChart() {
    if (typeof Highcharts === 'undefined') {
      console.error('Highcharts is not loaded');
      return;
    }

    this.charts.pie = Highcharts.chart('budget-pie-chart', {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent'
      },
      title: {
        text: null
      },
      tooltip: {
        pointFormat: '{series.name}: <b>${point.y:,.0f}</b> ({point.percentage:.1f}%)'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b><br>${point.y:,.0f}',
            style: {
              fontSize: '12px'
            }
          },
          showInLegend: true
        }
      },
      series: [{
        name: 'Budget',
        colorByPoint: true,
        data: []
      }]
    });
  }

  createBarChart() {
    if (typeof Highcharts === 'undefined') {
      console.error('Highcharts is not loaded');
      return;
    }

    this.charts.bar = Highcharts.chart('budget-bar-chart', {
      chart: {
        type: 'column',
        backgroundColor: 'transparent'
      },
      title: {
        text: null
      },
      xAxis: {
        categories: [],
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Cost ($)'
        },
        labels: {
          format: '${value:,.0f}'
        }
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>${point.y:,.0f}</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: [{
        name: 'Cost',
        data: []
      }]
    });
  }

  createFlightCostsChart() {
    if (typeof Highcharts === 'undefined') {
      console.error('Highcharts is not loaded');
      return;
    }

    this.charts.flight = Highcharts.chart('flight-costs-chart', {
      chart: {
        type: 'bar',
        backgroundColor: 'transparent'
      },
      title: {
        text: null
      },
      xAxis: {
        categories: [],
        title: {
          text: null
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Flight Cost ($)'
        },
        labels: {
          format: '${value:,.0f}'
        }
      },
      legend: {
        enabled: false
      },
      tooltip: {
        pointFormat: '<b>${point.y:,.0f}</b>'
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '${point.y:,.0f}'
          }
        }
      },
      series: [{
        name: 'Flight Cost',
        data: []
      }]
    });
  }

  updateCharts(results) {
    this.updatePieChart(results);
    this.updateBarChart(results);
    this.updateFlightCostsChart();
  }

  updatePieChart(results) {
    if (!this.charts.pie || !this.charts.pie.series || !this.charts.pie.series[0]) {
      console.warn('Pie chart not properly initialized');
      return;
    }

    const categories = [
      { name: 'Accommodation', amount: results.accommodationTotal },
      { name: 'Travel', amount: results.travelTotal },
      { name: 'Food & Beverages', amount: results.foodBeveragesTotal },
      { name: 'Activities & Entertainment', amount: results.activitiesEntertainmentTotal },
      { name: 'Conference & Meeting Space', amount: results.conferenceMeetingTotal },
      { name: 'Additional Costs', amount: results.additionalCostsTotal }
    ];

    const pieData = categories.map(category => ({
      name: category.name,
      y: category.amount
    }));

    this.charts.pie.series[0].setData(pieData);
  }

  updateBarChart(results) {
    if (!this.charts.bar || !this.charts.bar.series || !this.charts.bar.series[0]) {
      console.warn('Bar chart not properly initialized');
      return;
    }

    const categories = [
      'Accommodation',
      'Travel',
      'Food & Beverages',
      'Activities & Entertainment',
      'Conference & Meeting Space',
      'Additional Costs'
    ];

    const barData = [
      results.accommodationTotal,
      results.travelTotal,
      results.foodBeveragesTotal,
      results.activitiesEntertainmentTotal,
      results.conferenceMeetingTotal,
      results.additionalCostsTotal
    ];

    this.charts.bar.xAxis[0].setCategories(categories);
    this.charts.bar.series[0].setData(barData);
  }

  updateFlightCostsChart() {
    if (!this.charts.flight) {
      return; // Chart not yet initialized
    }
    
    const flightCosts = this.getFlightCosts();
    
    const categories = flightCosts.map(flight => flight.name);
    const data = flightCosts.map(flight => flight.cost);

    this.charts.flight.xAxis[0].setCategories(categories);
    this.charts.flight.series[0].setData(data);
  }

  calculateBudget() {
    if (!this.hasValidInputs()) {
      alert('Please enter the number of attendees and event duration to calculate the budget.');
      return;
    }

    const attendeeCount = parseInt($('#attendee-count').text());
    const eventDuration = parseInt($('#event-duration').val());

    // Calculate accommodation costs
    const hotelRate = parseFloat($('#hotel-rate').val()) || 0;
    const roomsNeeded = parseInt($('#rooms-needed').val()) || 0;
    const accommodationTotal = hotelRate * roomsNeeded * eventDuration;

    // Calculate travel costs
    const flightCosts = this.getFlightCosts();
    const totalFlightCost = flightCosts.reduce((sum, flight) => sum + flight.cost, 0);
    const groundTransportation = parseFloat($('#ground-transportation').val()) || 0;
    const parkingFees = parseFloat($('#parking-fees').val()) || 0;
    const rentalCars = parseFloat($('#rental-cars').val()) || 0;

    const travelTotal = totalFlightCost + 
                       (groundTransportation * attendeeCount) + 
                       (parkingFees * eventDuration) + 
                       (rentalCars * eventDuration);

    // Calculate food & beverages
    const breakfastCost = parseFloat($('#breakfast-cost').val()) || 0;
    const lunchCost = parseFloat($('#lunch-cost').val()) || 0;
    const dinnerCost = parseFloat($('#dinner-cost').val()) || 0;
    const snacksBeverages = parseFloat($('#snacks-beverages').val()) || 0;
    const welcomeDinner = parseFloat($('#welcome-dinner').val()) || 0;
    const farewellDinner = parseFloat($('#farewell-dinner').val()) || 0;

    const foodBeveragesTotal = (breakfastCost + lunchCost + dinnerCost + snacksBeverages) * attendeeCount * eventDuration + 
                              (welcomeDinner + farewellDinner) * attendeeCount;

    // Calculate activities & entertainment
    const teamBuildingActivities = parseFloat($('#team-building-activities').val()) || 0;
    const guidedTours = parseFloat($('#guided-tours').val()) || 0;
    const adventureActivities = parseFloat($('#adventure-activities').val()) || 0;
    const eveningEntertainment = parseFloat($('#evening-entertainment').val()) || 0;
    const photographyVideography = parseFloat($('#photography-videography').val()) || 0;
    const swagGifts = parseFloat($('#swag-gifts').val()) || 0;

    const activitiesEntertainmentTotal = (teamBuildingActivities + guidedTours + adventureActivities + eveningEntertainment) * attendeeCount + 
                                        photographyVideography + (swagGifts * attendeeCount);

    // Calculate conference & meeting space
    const conferenceRoomRental = parseFloat($('#conference-room-rental').val()) || 0;
    const avEquipment = parseFloat($('#av-equipment').val()) || 0;
    const wifiInternet = parseFloat($('#wifi-internet').val()) || 0;
    const meetingSupplies = parseFloat($('#meeting-supplies').val()) || 0;

    const conferenceMeetingTotal = (conferenceRoomRental * eventDuration) + avEquipment + wifiInternet + meetingSupplies;

    // Calculate additional costs
    const insurance = parseFloat($('#insurance').val()) || 0;
    const permitsLicenses = parseFloat($('#permits-licenses').val()) || 0;
    const emergencyFund = parseFloat($('#emergency-fund').val()) || 0;
    const miscCosts = parseFloat($('#misc-costs').val()) || 0;

    const additionalCostsTotal = insurance + permitsLicenses + emergencyFund + miscCosts;

    // Calculate totals
    const totalBudget = accommodationTotal + travelTotal + foodBeveragesTotal + 
                       activitiesEntertainmentTotal + conferenceMeetingTotal + additionalCostsTotal;
    const perPersonCost = totalBudget / attendeeCount;

    // Display results
    const results = {
      accommodationTotal,
      travelTotal,
      foodBeveragesTotal,
      activitiesEntertainmentTotal,
      conferenceMeetingTotal,
      additionalCostsTotal,
      totalBudget,
      perPersonCost,
      attendeeCount,
      eventDuration
    };

    this.displayResults(results);
    this.updateCharts(results);

    $('#gathering-results-section').show();
  }

  displayResults(results) {
    const breakdownList = $('#gathering-budget-breakdown-list');
    breakdownList.empty();

    const categories = [
      { name: 'Accommodation', amount: results.accommodationTotal, color: 'success' },
      { name: 'Travel', amount: results.travelTotal, color: 'info' },
      { name: 'Food & Beverages', amount: results.foodBeveragesTotal, color: 'warning' },
      { name: 'Activities & Entertainment', amount: results.activitiesEntertainmentTotal, color: 'danger' },
      { name: 'Conference & Meeting Space', amount: results.conferenceMeetingTotal, color: 'secondary' },
      { name: 'Additional Costs', amount: results.additionalCostsTotal, color: 'dark' }
    ];

    categories.forEach(category => {
      const percentage = ((category.amount / results.totalBudget) * 100).toFixed(1);
      const breakdownItem = `
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="d-flex align-items-center">
            <div class="badge bg-${category.color} me-2" style="width: 12px; height: 12px;"></div>
            <span>${category.name}</span>
          </div>
          <div class="text-end">
            <div class="fw-bold">$${category.amount.toLocaleString()}</div>
            <small class="text-muted">${percentage}%</small>
          </div>
        </div>
      `;
      breakdownList.append(breakdownItem);
    });

    // Update summary values
    $('#total-gathering-budget').text(`$${results.totalBudget.toLocaleString()}`);
    $('#per-person-cost').text(`$${results.perPersonCost.toLocaleString()}`);
    $('#total-attendees').text(results.attendeeCount.toLocaleString());
    $('#event-duration-display').text(`${results.eventDuration} days`);
    
    // Update destination and hotel info
    const destination = $('#destination-city').val() || 'Not specified';
    const hotel = $('#hotel-name').val() || 'Not specified';
    $('#destination-display').text(destination);
    $('#hotel-display').text(hotel);
    
    // Update attendee count based on flight cost entries
    this.updateAttendeeCount();
  }

  // export removed per requirements
  /* printBudget() {
    const companyName = $('#company-name').val() || 'Your Company';
    const eventDate = $('#event-date').val();
    const attendeeCount = $('#attendee-count').val();
    const eventDuration = $('#event-duration').val();
    const destination = $('#destination-city').val() || 'Not specified';
    const hotel = $('#hotel-name').val() || 'Not specified';
    const flightCosts = this.getFlightCosts();
    
    const flightCostsHtml = flightCosts.length > 0 ? 
      flightCosts.map(flight => `<div>${flight.name}: $${flight.cost.toLocaleString()}</div>`).join('') :
      '<div>No flight costs specified</div>';
    
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Offsite Team Gathering Budget - ${companyName}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #333; padding-bottom: 20px; }
          .summary { margin: 20px 0; }
          .breakdown { margin: 20px 0; }
          .breakdown-item { display: flex; justify-content: space-between; margin: 10px 0; padding: 5px 0; border-bottom: 1px solid #eee; }
          .total { font-weight: bold; font-size: 1.2em; border-top: 2px solid #333; padding-top: 10px; }
          .details { margin: 20px 0; padding: 15px; background: #f8f9fa; border-radius: 5px; }
          @media print { body { margin: 0; } }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>Offsite Team Gathering Budget</h1>
          <h2>${companyName}</h2>
          <p>Event Date: ${eventDate} | Attendees: ${attendeeCount} | Duration: ${eventDuration} days</p>
          <p>Destination: ${destination} | Hotel: ${hotel}</p>
        </div>
        
        <div class="summary">
          <h3>Budget Summary</h3>
          <p><strong>Total Budget:</strong> ${$('#total-gathering-budget').text()}</p>
          <p><strong>Per Person:</strong> ${$('#per-person-cost').text()}</p>
          <p><strong>Attendees:</strong> ${$('#total-attendees').text()}</p>
          <p><strong>Duration:</strong> ${$('#event-duration-display').text()}</p>
        </div>
        
        <div class="details">
          <h3>Flight Costs by Person</h3>
          ${flightCostsHtml}
        </div>
        
        <div class="breakdown">
          <h3>Cost Breakdown</h3>
          ${$('#gathering-budget-breakdown-list').html()}
        </div>
        
        <div class="total">
          <div class="breakdown-item">
            <span>Total Budget:</span>
            <span>${$('#total-gathering-budget').text()}</span>
          </div>
        </div>
        
        <div style="margin-top: 40px; font-size: 0.9em; color: #666;">
          <p>Generated on ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}</p>
        </div>
      </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  } */

  resetCalculator() {
    $('#gathering-budget-form')[0].reset();
    $('#gathering-results-section').hide();
    $('#flight-costs-list').empty();
    this.setDefaultValues();
  }
}

export default OffsiteTeamGatheringCalculator;
